import { Button, Form, message, Typography } from "antd";
import { useEffect, useMemo, useState } from "react";
import { useFooterButton } from "../../pages/authentication/sign-up/signup-context";
import LilyButton from "../../components/button/lily-button";
import portalAPI from "../../api/api";
import { CREATE_PATIENT } from "../../api/URLs";
import moment from "moment";
import { formatAddress, formatGender, parseDob } from "../../exports/util";
import CopyInfoComponent from "../../components/copay-info.component";

const PatientInformation = () => {
  const { Text } = Typography;
  const [form] = Form.useForm();
  const [processing, setProcessing] = useState(0);
  const {
    patientForm,
    setFooterButton,
    setCurrent,
    setCurrentProcess,
    registrationToken,
  } = useFooterButton();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    form.setFieldsValue({
      dob: patientForm?.dob || null,
      gender: patientForm?.gender || "",
    });
  }, [patientForm, form]);

  const handleBack = () => {
    if (processing > 0) {
      setProcessing(processing - 1);
    } else {
      setCurrent(0);
    }
  };

  useMemo(() => {
    setCurrentProcess(processing);
    setFooterButton(
      <div className="d-flex flex-row justify-content-between">
        <Button onClick={handleBack} type="link">
          Back
        </Button>
        <LilyButton
          text="Next"
          style={{ width: "120px" }}
          size="large"
          onClick={() => handleSubmit(patientForm)}
          loading={isLoading}
        />
      </div>,
    );
  }, [processing, isLoading]);

  const filledDetails = (data) => {
    let fields = [
      {
        title: "Copay Card Member ID#",
        element: data?.memberId || "N/A",
      },
      {
        title: "Full Name",
        element: `${data?.firstName} ${data?.lastName}` || "N/A",
      },
      {
        title: "Date of Birth",
        element: data?.dob ? parseDob(data?.dob).format("MM/DD/YYYY") : "N/A",
      },
      {
        title: "Gender",
        element: data?.gender ? formatGender[data.gender] : "N/A",
      },
      {
        title: "Address",
        element: (
          <Text>
            {formatAddress({
              line1: data?.address?.line1 || "",
              line2: data?.address?.line2 || "",
              city: data?.address?.city || "",
              state: data?.address?.state || "",
              zip: data?.address?.zip || "",
            })}
          </Text>
        ),
      },
      {
        className: "d-flex flex-column gap-2",
        title: "Copay Card Processing Information",
        element: <CopyInfoComponent data={data} />,
      },
      {
        className: "d-flex flex-row gap-2",
        title: "Participating Program",
        element: <Text>{data?.copayCardInfo?.programName || "N/A"}</Text>,
      },
    ];
    return fields;
  };

  const handleSubmit = async (payload) => {
    setIsLoading(true);
    try {
      let rsp = await portalAPI.post(CREATE_PATIENT, payload, {
        headers: {
          Authorization: `Bearer ${registrationToken}`,
        },
      });
      if (rsp?.data?.status === 200) {
        message.success("Account authentication completed successfully.");
        setCurrent(2);
        setFooterButton(null);
      }
    } catch (error) {
      message.error(`Failed to create the patient`);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="d-flex flex-column gap-1 px-3">
      {filledDetails(patientForm).map((item) => {
        return (
          <div className={`${item.className || "d-flex flex-row gap-2"}`}>
            <Text>{item.title}:</Text>
            {item.element}
          </div>
        );
      })}
    </div>
  );
};

export default PatientInformation;
